import Network from 'lib/api/network';

export default {
  namespaced: true,

  state: {
    showMilestones: null, // Feature flag check, established in the controllers
    anniversary: null,
    birthday: null,
    celebrationPrograms: null,
    saveStatus: {},
  },

  getters: {
    pointsForEvent: (state) => (milestoneType, ordinal) => {
      const milestone = state[milestoneType];
      if (milestone.amount_mode === 'default_only') return milestone.default_points;

      const tier = milestone.points_by_year?.[ordinal];
      if (tier) return tier;
      return milestone.amount_mode === 'custom_only' ? 0 : milestone.default_points;
    },
  },

  mutations: {
    setSaveStatus(state, { type, status }) {
      state.saveStatus[type] = status;
    },
  },

  actions: {
    updateMilestoneConfig({ state, commit }, { type, params }) {
      const oldConfig = state[type];
      // Assume success; update optimistically
      commit('update', { module: 'bonusMilestoneConfigs', key: type, value: { ...oldConfig, ...params } }, { root: true });
      commit('setSaveStatus', { type, status: 'saving' });
      return new Promise((resolve, reject) => {
        Network.post('/bonus/milestones', { bonus_milestone_config: { milestone_type: type, ...params } }, {
          success: (newConfig) => {
            // Committing here is realistically redundant with update above, but can't hurt as a source of pure truth
            commit('update', { module: 'bonusMilestoneConfigs', key: type, value: newConfig }, { root: true });
            commit('setSaveStatus', { type, status: 'saved' });
            setTimeout(() => { if (state.saveStatus[type] === 'saved') commit('setSaveStatus', { type, status: null }); }, 500);
            resolve();
          },
          error: () => {
            commit('update', { module: 'bonusMilestoneConfigs', key: type, value: oldConfig }, { root: true });
            commit('setSaveStatus', { type, status: null });
            reject();
          },
        });
      });
    },

    fetchUpcomingDates(_store, params) {
      return new Promise((resolve, reject) => {
        const queryParams = new URLSearchParams(params);
        const url = `/bonus/milestones/upcoming_data?${queryParams}`;
        Network.get(url, {
          success: (data) => { resolve(data); },
          error: (error) => { reject(error); },
        });
      });
    },
  },
};
